import { Lesson } from '@/models/Lesson';
import { LessonContentTO } from '@/models/LessonContentTO';
import { LessonData } from '@/models/LessonData';
import { LessonStartAndFinishData } from '@/models/LessonStartAndFinishData';
import { LinkMetadata } from '@/models/LinkMetadata';
import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import { Lessons, LessonTypes } from './types';

export const getLessonRequest = (lessonId: number, refreshOnlyPath: boolean = false, isEvaluation: boolean = false) =>
    action(LessonTypes.GET_LESSON_REQUEST, { lessonId, refreshOnlyPath, isEvaluation });
export const getLessonSuccess = (data: Lesson) => action(LessonTypes.GET_LESSON_SUCCESS, data);
export const getLessonPathSuccess = (data: string) => action(LessonTypes.GET_LESSON_PATH_SUCCESS, data);
export const getLessonFailure = (error: AxiosError) => action(LessonTypes.GET_LESSON_FAILURE, error);
export const getLessonClear = () => action(LessonTypes.GET_LESSON_CLEAR);

export const getLMSLessonsRequest = (data: number) => action(LessonTypes.GET_LMS_LESSONS_REQUEST, data);
export const getLessonsRequest = (data: number) => action(LessonTypes.GET_LESSONS_REQUEST, data);
export const getLessonsSuccess = (data: Lessons) => action(LessonTypes.GET_LESSONS_SUCCESS, data);
export const getLessonsFailure = (error: AxiosError) => action(LessonTypes.GET_LESSONS_FAILURE, error);

export const setLessonLinkMetadataRequest = (data: string) => action(LessonTypes.SET_LESSON_EXTERNAL_LINK_METADATA_REQUEST, data);
export const setLessonLinkMetadataSuccess = (data: LinkMetadata | undefined) => action(LessonTypes.SET_LESSON_EXTERNAL_LINK_METADATA_SUCCESS, data);
export const setLessonLinkMetadataFailure = (error: AxiosError) => action(LessonTypes.SET_LESSON_EXTERNAL_LINK_METADATA_FAILURE, error);

export const postLessonRequest = (data: LessonData) => action(LessonTypes.POST_LESSON_REQUEST, data);
export const postLessonSuccess = (data: Lesson) => action(LessonTypes.POST_LESSON_SUCCESS, data);
export const postLessonFailure = (error: AxiosError) => action(LessonTypes.POST_LESSON_FAILURE, error);
export const postLessonClear = () => action(LessonTypes.POST_LESSON_CLEAR);

export const postEvaluationRequest = (data: LessonData) => action(LessonTypes.POST_EVALUATION_REQUEST, data);
export const postEvaluationSuccess = (data: Lesson) => action(LessonTypes.POST_EVALUATION_SUCCESS, data);
export const postEvaluationFailure = (error: AxiosError) => action(LessonTypes.POST_EVALUATION_FAILURE, error);
export const postEvaluationClear = () => action(LessonTypes.POST_EVALUATION_CLEAR);

export const putEvaluationLessonRequest = (data: LessonData) => action(LessonTypes.PUT_EVALUATION_LESSON_REQUEST, data);

export const putLessonRequest = (data: LessonContentTO) => action(LessonTypes.PUT_LESSON_REQUEST, data);
export const putLessonReorderRequest = (lessonId: number, order: number) => action(LessonTypes.PUT_LESSON_REORDER_REQUEST, { lessonId, order });
export const putLessonSuccess = () => action(LessonTypes.PUT_LESSON_SUCCESS);
export const putLessonFailure = (error: AxiosError) => action(LessonTypes.PUT_LESSON_FAILURE, error);
export const putLessonClear = () => action(LessonTypes.PUT_LESSON_CLEAR);

export const deleteLessonRequest = (data: number) => action(LessonTypes.DELETE_LESSON_REQUEST, data);
export const deleteLessonSuccess = (data: number) => action(LessonTypes.DELETE_LESSON_SUCCESS, data);
export const deleteLessonFailure = (error: AxiosError) => action(LessonTypes.DELETE_LESSON_FAILURE, error);
export const deleteLessonClear = () => action(LessonTypes.DELETE_LESSON_CLEAR);

export const startLessonRequest = (data: LessonStartAndFinishData) => action(LessonTypes.START_LESSON_REQUEST, data);
export const startLessonSuccess = (data: string) => action(LessonTypes.START_LESSON_SUCCESS, data);
export const startLessonFailure = () => action(LessonTypes.START_LESSON_FAILURE);

export const finishLessonRequest = (data: number) => action(LessonTypes.FINISH_LESSON_REQUEST, data);
export const finishLessonSuccess = () => action(LessonTypes.FINISH_LESSON_SUCCESS);
export const finishLessonFailure = () => action(LessonTypes.FINISH_LESSON_FAILURE);

export const setCurrentLessonForEdition = (data: Lesson | undefined) => action(LessonTypes.SET_CURRENT_LESSON_FOR_EDITION, data);

export const decreaseLessonQuestionsAmount = (lessonId: number) => action(LessonTypes.DECREASE_LESSON_QUESTIONS_AMOUNT, { lessonId });
export const increaseLessonQuestionsAmount = (lessonId: number) => action(LessonTypes.INCREASE_LESSON_QUESTIONS_AMOUNT, { lessonId });
export const clearStartSuccess = () => action(LessonTypes.CLEAR_START_SUCCESS);
